import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import TopBar from '../../components/TopBar'
import provinces from '../../data/provinces'
import districts from '../../data/districts'
import subdistricts from '../../data/subdistricts'
import _ from 'lodash'

import Modal from '@material-ui/core/Modal'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  container: {
    backgroundColor: '#eff0f4',
  },
  list: {
    margin: '0',
    padding: '0',
    listStyle: 'none',
  },
  listItem: {
    paddingLeft: '16px',
  },
  listItemContent: {
    borderBottom: 'solid 1px #dee1e9',
    padding: '16px 0',
  },
  listItemText: {
    color: '#0e162c',
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    fontSize: '16px',
  },
  fieldInput: {
    width: '100%',
    padding: '16px',
    ...fontDefault,
    fontSize: '16px',
    color: '#333333',
    borderRadius: '8px',
    border: 'none',
    '&:focus': {
      outlineWidth: '0',
    },
    '&::placeholder': {
      color: '#cdd2de',
    },
  },
  inputContainerInput: {
    border: '1px solid #ffffff',
    margin: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}

class AddressPicker extends Component {
  state = {
    currentStep: 0,
    province: null,
    district: null,
    subdistrict: null,
    filterText: '',
  }

  backButton = () => {
    this.goToTop()
    const { currentStep } = this.state
    switch (currentStep) {
      case 0:
        const { onBack = () => {} } = this.props
        onBack()
        break
      case 1:
        this.setState({
          currentStep: 0,
          filterText: '',
        })
        break
      case 2:
        this.setState({
          currentStep: 1,
          filterText: '',
        })
        break
      default:
        break
    }
  }

  pickSubDistrict = subdistrict => () => {
    const { province, district } = this.state
    const { onBack = () => {}, setUserInput } = this.props
    const fullAddress =
      _.get(province, 'jw_name', '') +
      ' ' +
      _.get(district, 'name', '') +
      ' ' +
      _.get(subdistrict, 'name', '') +
      ' ' +
      _.get(subdistrict, 'zipcode', '')
    const moreAddress = { province, district, subdistrict, fullAddress }
    setUserInput({
      moreAddress,
    })
    onBack()
    this.setState({
      currentStep: 0,
    })
    this.goToTop()
  }

  goToTop = () => {
    const presentation = document.querySelector('[role="presentation"]')
    if (presentation) {
      presentation.scrollTop = 0
    }
  }

  pickDistrict = district => () => {
    this.goToTop()
    this.setState({
      district,
      currentStep: 2,
      filterText: '',
    })
  }

  pickProvince = province => () => {
    this.goToTop()
    this.setState({
      province,
      currentStep: 1,
      filterText: '',
    })
  }

  render() {
    const { classes, open } = this.props
    const { filterText, currentStep, province, district } = this.state
    let title = ''
    switch (currentStep) {
      case 0:
        title = 'เลือกจังหวัด'
        break
      case 1:
        title = 'เลือกอำเภอ'
        break
      case 2:
        title = 'เลือกตำบล'
        break
      default:
        break
    }
    return (
      <Modal
        style={{
          outline: 0,
          overflow: 'auto',
          height: '100%',
          display: 'block',
        }}
        open={open}
      >
        <Wrapper>
          <Header>
            <TopBar arrowLeft={this.backButton}>
              <Typography align="center" className={classes.textTopBar}>
                {title}
              </Typography>
            </TopBar>
          </Header>
          <Body style={{ backgroundColor: '#eff0f4', overflow: 'auto' }}>
            <div className={classes.container}>
              <Grid container>
                <Grid item xs={12}>
                  <div className={classes.inputContainerInput}>
                    <input
                      className={classes.fieldInput}
                      type="text"
                      placeholder="ค้นหา"
                      autoFocus
                      value={filterText}
                      onChange={event => {
                        this.setState({
                          filterText: event.target.value,
                        })
                      }}
                    />
                  </div>
                  {(() => {
                    switch (currentStep) {
                      case 0:
                        const filteredProvinces = provinces
                          .filter(p => {
                            return _.get(p, 'jw_name', '').match(filterText)
                          })
                          .sort((a, b) => {
                            if (
                              _.get(a, 'jw_name', '') < _.get(b, 'jw_name', '')
                            ) {
                              return -1
                            }
                            if (
                              _.get(a, 'jw_name', '') > _.get(b, 'jw_name', '')
                            ) {
                              return 1
                            }
                            return 0
                          })
                        return (
                          <ul className={classes.list}>
                            {filteredProvinces.map(province => {
                              return (
                                <li
                                  className={classes.listItem}
                                  onClick={this.pickProvince(province)}
                                >
                                  <div className={classes.listItemContent}>
                                    <span className={classes.listItemText}>
                                      {_.get(province, 'jw_name', '')}
                                    </span>
                                  </div>
                                </li>
                              )
                            })}
                          </ul>
                        )
                      case 1:
                        const targetDistricts = _.get(
                          districts,
                          _.get(province, 'jw_code', ''),
                          []
                        )
                        const filteredDistricts = targetDistricts
                          .filter(p => {
                            return _.get(p, 'name', '').match(filterText)
                          })
                          .sort((a, b) => {
                            if (_.get(a, 'name', '') < _.get(b, 'name', '')) {
                              return -1
                            }
                            if (_.get(a, 'name', '') > _.get(b, 'name', '')) {
                              return 1
                            }
                            return 0
                          })
                        return (
                          <ul className={classes.list}>
                            {filteredDistricts.map(district => {
                              return (
                                <li
                                  className={classes.listItem}
                                  onClick={this.pickDistrict(district)}
                                >
                                  <div className={classes.listItemContent}>
                                    <span className={classes.listItemText}>
                                      {_.get(district, 'name', '')}
                                    </span>
                                  </div>
                                </li>
                              )
                            })}
                          </ul>
                        )
                      case 2:
                        const targetSubdistricts = _.get(
                          subdistricts,
                          _.get(province, 'jw_code', '') +
                            '-' +
                            _.get(district, 'amph_code', ''),
                          []
                        )
                        const filteredSubdistricts = targetSubdistricts
                          .filter(p => {
                            return _.get(p, 'name', '').match(filterText)
                          })
                          .sort((a, b) => {
                            if (_.get(a, 'name', '') < _.get(b, 'name', '')) {
                              return -1
                            }
                            if (_.get(a, 'name', '') > _.get(b, 'name', '')) {
                              return 1
                            }
                            return 0
                          })
                        return (
                          <ul className={classes.list}>
                            {filteredSubdistricts.map(subdistrict => {
                              return (
                                <li
                                  className={classes.listItem}
                                  onClick={this.pickSubDistrict(subdistrict)}
                                >
                                  <div className={classes.listItemContent}>
                                    <span className={classes.listItemText}>
                                      {_.get(subdistrict, 'name', '')}
                                    </span>
                                  </div>
                                </li>
                              )
                            })}
                          </ul>
                        )
                      default:
                        return null
                    }
                  })()}
                </Grid>
              </Grid>
            </div>
          </Body>
        </Wrapper>
      </Modal>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddressPicker))
